import { Spinner, TextControl, Button, ToggleControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { store as coreDataStore } from '@wordpress/core-data';
import { useState } from '@wordpress/element';

export default function Search({ attribute, setAttribute }) {
    const [search, setSearch] = useState('')

    const { pages, hasResolved } = useSelect(
        (select) => {
            const query = { per_page: 20 };
            if (search) {
                query.search = search;
            }
            const selectorArgs = ['postType', 'page', query];
            return {
                pages: select(coreDataStore).getEntityRecords(
                    ...selectorArgs
                ),
                hasResolved: select(coreDataStore).hasFinishedResolution(
                    'getEntityRecords',
                    selectorArgs
                ),
            };
        },
        [search]
    );

    const PageList = ({ hasResolved, pages }) => {

        if (!hasResolved) {
            return <Spinner />;
        }
        if (!pages?.length) {
            return <div>No results</div>;
        }

        return (
            <>
                <table className="wp-list-table widefat striped table-view-list">
                    <thead>
                        <tr>
                            <td>Title</td>
                        </tr>
                    </thead>
                    <tbody>
                        {pages?.map((page) => (
                            <tr
                                className="hover:cursor-pointer"
                                key={page.guid.rendered}
                                onClick={() => {
                                    setSearch('')
                                    setAttribute({ title: "Page: " + page.title.rendered, url: page.link })
                                }}
                            >
                                <td>{page?.title?.rendered}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        )
    }

    return (
        <div>
            <div style={{ marginTop: "1rem", marginBottom: "0.4rem", textTransform: "uppercase", fontSize: "11px", fontWeight: "500", lineHeight: "1.4" }}>
                Button link
            </div>
            {!attribute?.url &&
                <>
                    <div className='flex align-top gap-1'>
                        <TextControl
                            value={search}
                            onChange={newValue => setSearch(newValue)}
                        />
                        <Button
                            variant="primary"
                            onClick={() => setAttribute({ title: search, url: search })}
                        >
                            Save
                        </Button>
                    </div>
                    {search && (
                        <PageList hasResolved={hasResolved} pages={pages} />
                    )}
                </>
            }

            {attribute?.url &&
                <div className="flex flex-col">
                    <a href={attribute?.url} target="_blank">{attribute?.title}</a>
                    <Button
                        variant="link"
                        isDestructive
                        onClick={() => {
                            setSearch(attribute.url)
                            setAttribute({ title: "", url: "" })
                        }}
                    >
                        Remove link
                    </Button>

                    <ToggleControl
                        checked={attribute?.buttonToNewPage || false}
                        className="mt-6"
                        label="Open in new tab"
                        onChange={buttonToNewPage => setAttribute({ ...attribute, buttonToNewPage })}
                    />
                </div>
            }
        </div>
    )
}